import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../../brand-settings.setup';

const parent: SetupPage = BrandSettings.pages.general;
const path = 'payment-channels';
const title = 'PAGE.BRAND_SETTINGS.GENERAL.PAYMENT_CHANNELS.TITLE';
const res = ['actions', 'actions.editAvailability'];
export const BrandSettingsGeneralPaymentChannelsTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
